import React from "react";

import { useBusinessScheduleLogic } from "../Logic/BusinessSchedule";
import BusinessScheduleUI from "../UI/BusinessScheduleUI";
const BusinessSchedule = () => {
  const {
    schedule,
    vacationStart,
    vacationEnd,
    handleDayToggle,
    handleContinuousToggle,
    handleTimeChange,
    handlePeriodChange,
    handleDateChange,
    submit,
    parseISO,
    format,
  } = useBusinessScheduleLogic();
  return (
    <BusinessScheduleUI
      addEnableButton={true}
      schedule={schedule}
      vacationEnd={vacationEnd}
      vacationStart={vacationStart}
      handleDayToggle={handleDayToggle}
      handleContinuousToggle={handleContinuousToggle}
      handleTimeChange={handleTimeChange}
      handlePeriodChange={handlePeriodChange}
      handleDateChange={handleDateChange}
      submit={submit}
      parseISO={parseISO}
      format={format}
    />
  );
};

export default BusinessSchedule;
